import { useEffect } from "react";
import { SearchContext } from "../../core/types/event";
import { WidgetEvents } from "../../services/";

interface Params {
  searchQuery: string;
  resultsLength: number;
  debounceMs?: number;
  context: SearchContext;
}

/**
 * Dispatches a `searchEmpty` event when the search query has no results
 */
export function useTrackSearchEmpty({
  searchQuery,
  resultsLength,
  context,
  debounceMs = 500,
}: Params) {
  useEffect(() => {
    const isSearchEmpty = resultsLength <= 0 && searchQuery.length >= 3;

    if (!isSearchEmpty) return;

    const timeout = setTimeout(() => {
      WidgetEvents.getInstance().dispatchSearchEmpty({
        searchQuery,
        context,
      });
    }, debounceMs);

    return () => {
      clearTimeout(timeout);
    };
  }, [context, debounceMs, resultsLength, searchQuery]);
}
